import { ref, watch, type Ref } from 'vue'
import { useDebounceFn, useLocalStorage } from '@vueuse/core'
import { STORAGE_KEYS } from '@/enums/StorageEnum.ts'

interface UseDocumentFiltersOptions {
  documentTypes: Ref<{ value: string; label: string }[]>
  onFiltersChange?: (filters: { q: string; types: string[] }) => void
}

export function useDocumentFilters({
  documentTypes: _documentTypes,
  onFiltersChange,
}: UseDocumentFiltersOptions) {
  const searchTerm = ref('')
  const storedTypes = useLocalStorage<string[]>(STORAGE_KEYS.KNOWLEDGE, [])
  const selectedTypes = ref<string[]>([])
  const initialLoadComplete = ref(false)

  const loadPreferences = () => {
    return {
      types: storedTypes.value,
    }
  }

  const debouncedFiltersChange = onFiltersChange
    ? useDebounceFn(() => {
        onFiltersChange({
          q: searchTerm.value,
          types: selectedTypes.value,
        })
      }, 100)
    : undefined

  watch(
    [searchTerm, selectedTypes],
    () => {
      if (!initialLoadComplete.value) return
      storedTypes.value = selectedTypes.value
      void debouncedFiltersChange?.()
    },
    { immediate: false },
  )

  return {
    searchTerm,
    selectedTypes,
    initialLoadComplete,
    loadPreferences,
  }
}
